import { defineComponent as _defineComponent } from 'vue'

import { PropType, computed, defineComponent, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude, useBranchService, useI18n, useLinkService } from "@/composables";
import { useCreatorShop } from "@/store/creator-shop";
import { getGiftGuidesStore } from "@/store/gift-guides";
import { getProductDetailsStore } from "@/store/product-details";

const __default__ = defineComponent({
  name: "GiftGuideProductTile",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  shopProductId: {
    type: String,
    required: true,
  },
  giftGuideEventProps: {
    type: Object as PropType<{ [key: string]: string | boolean | undefined }>,
    required: false,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const store = useStore();
const route = useRoute();
const amplitude = useAmplitude();
const i18n = useI18n();
const linkService = useLinkService();
const branch = useBranchService();
const giftGuideStore = getGiftGuidesStore(store);

const giftGuideId = computed(() => route.value.params.id);
const product = computed(() => {
  const productDetailsId = giftGuideStore.giftGuideProducts[props.shopProductId]?.productReferenceId ?? "";
  const productDetails = getProductDetailsStore(store).productDetails[productDetailsId];
  return productDetails;
});
const productTitle = computed(() => product.value?.name || "");

const retailerProductId = computed(() => product.value?.catalogRetailerProductId);

const isRetailerProduct = computed(() => Boolean(product.value?.hasVariants && retailerProductId.value));

const price = computed(() => {
  const localPrice = product.value?.localPrice;
  const currency = product.value?.currency;
  const price = product.value?.price;

  if (localPrice && currency) {
    return Intl.NumberFormat(i18n.locale, { style: "currency", currency }).format(Number(localPrice));
  }
  return Intl.NumberFormat(i18n.locale, { style: "currency", currency: "USD" }).format(Number(price));
});

const imageUrl = computed(() => {
  // Use the image from shopProducts response over productDetails as its more reliable
  return [giftGuideStore.giftGuideProducts[props.shopProductId]?.imageUrl];
});

const linkUrl = computed(() => {
  if (isRetailerProduct.value) {
    return linkService.getProductDetailsLink({
      productDetailsId: product.value?.id,
      productSetId: giftGuideId.value,
    });
  }

  const linkUrl = giftGuideStore.giftGuideProducts[props.shopProductId]?.linkUrl;

  return linkService.getProductLink({
    url: linkUrl ?? "",
    page: "product-set-details",
    priceDropPercent: product.value?.percentChange,
  });
});

const onClick = () => {
  useCreatorShop().setReferringShopTab();
  amplitude?.sendExitEvent("/product-browser", {
    "product-id": product.value?.id ?? "",
    "advertiser-name": product.value?.advertiserName ?? "",
    "branch-journey-creative-name": branch.lastDisplayedBanner,
    "referring-component": amplitude?.getReferringComponentByPage(route.value.name ?? "", "product feed"),
    ...(isRetailerProduct.value && { "ltk-direct-platform": "shopify" }),
    url: linkUrl.value ?? "",
    ...props.giftGuideEventProps,
  });
};

return { __sfc: true,props, store, route, amplitude, i18n, linkService, branch, giftGuideStore, giftGuideId, product, productTitle, retailerProductId, isRetailerProduct, price, imageUrl, linkUrl, onClick }
}

})